import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDocfile } from "../../entity/EntityDocfile";

export class DtoDocfilesGetRes extends EntityDocfile {
  public items: EntityDocfile[]  = [];
}
